import React, { useContext, useEffect, useState } from "react";
import * as XLSX from "xlsx-js-style";
import { AuthContext, LoaderContext } from "../../Context/ContextFunctions";
import { FaEdit, FaFileExport } from "react-icons/fa";
import NoResultFoundModel from "../../components/common/NoDataFound";
import PaginationComponent from "../../components/common/PaginationModal";
import { GetJobCategoryLookupList, GetJobList, GetJobReportList } from "../../services/Job/JobApi";
import { Dialog, DialogContent, DialogTitle, Tooltip } from "@mui/material";
import Android12Switch from "../../components/common/AndroidSwitch";
import { MdOutlinePreview } from "react-icons/md";
import Select from "react-select";
import { globalSelectStyles } from "../../middleware/enum";
import { GetClientLookupList } from "../../services/Client/ClientApi";
import { GetAllProjectLookupList, GetProjectLookupList } from "../../services/Project/projectApi";
import { GeStatusLookupList, GetAllUserLookupList } from "../../services/Staff/StaffApi";
import { GetProfitLossReport, GetProjectLeadgerData } from "../../services/Reports/ReportsApi";


export default function ProfitLossReportComponent() {
    //========================constant=======================
    const { userKeyID } = JSON.parse(localStorage.getItem("login"))
    const { setLoader } = useContext(LoaderContext);
    const { pageSize } = useContext(AuthContext);

    // =================== Column Configs =====================
    const tableColumnsConfig = [
        { key: "projectName", label: "Project Name", },
        { key: "clientToCost", label: "Client To Cost (₹)" },
        { key: "technolandToCost", label: "Technoland To Cost (₹)" },
        { key: "clientToCostPnL", label: "Client To Cost P&L (₹)" },
        { key: "technolandToCostPnL", label: "Technoland To Cost P&L (₹)" },
    ]

    //========================state=======================
    const [valueSearch, setValueSearch] = useState(null);
    const [searchTimer, setSearchTimer] = useState(null);
    const [tableRows, setTableRows] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalRecords, setTotalRecords] = useState(0);
    const [lookupList, setLookupList] = useState({
        clientList: [],
        projectList: [],
        employeeList: [],
        jobCategoryList: [],
        statusList: [],
    })
    const [listId, setListId] = useState({
        clientID: null,
        projectID: null,
        userID: null,
        jobCateogryID: null,
        jobStatusID: null
    });

    const [appliedFilter, setAppliedFilter] = useState({
        userKeyID: userKeyID,
        pageNo: 0,
        pageSize: pageSize,
        sortingDirection: null,
        sortingColumnName: null,
        searchKeyword: null,
        fromDate: null,
        toDate: null,

    })
    const [openPnLDialog, setOpenPnLDialog] = useState(false);
    const [selectedPnL, setSelectedPnL] = useState(null);
    const [ledgerRows, setLedgerRows] = useState([]);

    //========================useEffect======================= 
    // useEffect(() => {
    //     const fetchLookupData = async () => {
    //         setLoader(true);
    //         try {
    //             const [
    //                 clientRes,
    //                 employeeRes,
    //                 categoryRes,
    //                 statusRes,
    //             ] = await Promise.all([
    //                 GetClientLookupList(),
    //                 GetAllUserLookupList(),
    //                 GetJobCategoryLookupList(),
    //                 GeStatusLookupList()
    //             ]);

    //             setLookupList({
    //                 clientList: mapToSelectOptions(
    //                     clientRes?.responseData?.data || [],
    //                     "clientName",
    //                     "clientID"
    //                 ),

    //                 employeeList: mapToSelectOptions(
    //                     employeeRes?.responseData?.data || [],
    //                     "name",
    //                     "userID"
    //                 ),

    //                 jobCategoryList: mapToSelectOptions(
    //                     categoryRes?.responseData?.data || [],
    //                     "jobCategoryName",
    //                     "jobCategoryID"
    //                 ),

    //                 projectList: [],   // add later if needed
    //                 statusList: mapToSelectOptions(
    //                     statusRes?.responseData?.data || [],
    //                     "projectStatusName",
    //                     "projectStatusID"
    //                 ),
    //             });
    //         } catch (error) {
    //             console.log("Lookup fetch error:", error);
    //         } finally {
    //             setLoader(false);
    //         }
    //     };

    //     fetchLookupData();
    // }, []);



    useEffect(() => {

        async function fetchData() {
            setLoader(true);
            const response = await GetProfitLossReport({
                ...appliedFilter,
            });
            setLoader(false);

            if (response?.statusCode == 200) {

                setTableRows(response.responseData.data);
                setTotalRecords(response?.totalCount || response?.responseData?.data?.length || 0);
            } else {
                setTableRows([]);
                setTotalRecords(0);
            }
        }

        fetchData();
    }, [appliedFilter]);

    //========================functions=======================
    const mapToSelectOptions = (list = [], labelKey, valueKey) => {
        return list.map(item => ({
            label: item[labelKey],
            value: item[valueKey],
        }));
    };

    const handleJobExport = () => {
        const wb = XLSX.utils.book_new();

        const titleText = "Title: Profit & Loss Report";
        const headers = [
            "Project Name",
            "Client To Cost (₹)",
            "Technoland To Cost (₹)",
            "Client To Cost P&L (₹)",
            "Technoland To Cost P&L (₹)",
        ];

        const data = tableRows.map((row) => [
            row.projectName || "-",
            row.clientToCost || "-",
            row.technolandToCost || "-",
            row.clientToCostPnL || "-",
            row.technolandToCostPnL || "0"

        ]);

        const ws_data = [[titleText], [], headers, ...data];

        const ws = XLSX.utils.aoa_to_sheet(ws_data);

        // Merge title row
        ws["!merges"] = [{ s: { r: 0, c: 0 }, e: { r: 0, c: headers.length - 1 } }];
        ws["A1"].s = {
            font: { bold: true, sz: 14 },
            alignment: { horizontal: "left", vertical: "left" },
        };

        // Header row styling (row 2 / index 2)
        headers.forEach((_, col) => {
            const cellAddr = XLSX.utils.encode_cell({ c: col, r: 2 });
            if (ws[cellAddr]) {
                ws[cellAddr].s = {
                    font: { bold: true, color: { rgb: "000000" } },
                    fill: { fgColor: { rgb: "D9E1F2" } }, // Light blue
                    alignment: { horizontal: "center", vertical: "center" },
                    border: {
                        top: { style: "medium", color: { rgb: "000000" } },
                        bottom: { style: "medium", color: { rgb: "000000" } },
                        left: { style: "medium", color: { rgb: "000000" } },
                        right: { style: "medium", color: { rgb: "000000" } },
                    },
                };
            }
        });

        // Data row styling
        for (let r = 3; r < data.length + 3; r++) {
            for (let c = 0; c < headers.length; c++) {
                const cellAddr = XLSX.utils.encode_cell({ c, r });
                if (ws[cellAddr]) {
                    ws[cellAddr].s = {
                        font: { color: { rgb: "000000" } },
                        alignment: { horizontal: "center", vertical: "center" },
                        border: {
                            top: { style: "thin", color: { rgb: "000000" } },
                            bottom: { style: "thin", color: { rgb: "000000" } },
                            left: { style: "thin", color: { rgb: "000000" } },
                            right: { style: "thin", color: { rgb: "000000" } },
                        },
                    };

                    // Zebra styling for alternating rows
                    if ((r - 3) % 2 === 1) {
                        ws[cellAddr].s.fill = { fgColor: { rgb: "F9F9F9" } };
                    }
                }
            }
        }

        // Column widths for readability
        ws["!cols"] = headers.map((h) => ({ wch: h.length + 8 }));

        XLSX.utils.book_append_sheet(wb, ws, "Profit Loss Report");
        XLSX.writeFile(wb, "Profit_Loss_Report.xlsx");
    };

    const handleSearchFunction = (searchValue) => {
        setValueSearch(searchValue);

        // Clear old timer so API doesn't fire immediately
        if (searchTimer) clearTimeout(searchTimer);

        // Set new timer
        const timer = setTimeout(() => {
            setAppliedFilter({
                ...appliedFilter,
                searchKeyword: searchValue || null,
            });
        }, 500); // 500ms delay

        setSearchTimer(timer);
    };

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
        setAppliedFilter((prev) => ({ ...prev, pageNo: pageNumber - 1 }));
    }

    const handlePnLClick = async (value, row, type) => {
        try {
            const res = await GetProjectLeadgerData({
                keyID: row.projectKeyID,
                fromDate: appliedFilter.fromDate,
                toDate: appliedFilter.toDate
            });

            if (res?.statusCode === 200) {
                setLedgerRows(res?.responseData?.data || []);
                setOpenPnLDialog(true);
            }
        } catch (error) {
            console.log("error ==>>", error);
        }
    };


    const handleCloseDialog = () => {
        setOpenPnLDialog(false);
        setSelectedPnL(null);
    };


    //=====================render table=====================
    const renderTable = (columns = [], data = []) => {
        if (!columns.length) return null;

        return (
            <div className="flex flex-col table_wrapper border border-gray-200">
                <div className="flex-1 overflow-x-auto">
                    <table className="w-full border-collapse border border-gray-200 text-12 table-auto">
                        <thead>
                            <tr className="z-1 sticky top-0 bg-white">
                                {columns.map((col) => (
                                    <th
                                        key={col.key}
                                        className="text-12 border-b border-slate-200 bg-slate-50 whitespace-nowrap p-1"
                                    >
                                        {col.label}
                                    </th>
                                ))}

                            </tr>
                        </thead>
                        <tbody>
                            {data.length > 0 ? (
                                data.map((client, index) => (
                                    <tr
                                        key={index}
                                        className="hover:bg-slate-50 border-b border-slate-200 text-center"
                                    >
                                        {columns.map((col) => {
                                            const value = client[col.key] ?? "-";
                                            const isLongText = typeof value === "string" && value.length > 50;


                                            if (col.key === "clientToCostPnL" || col.key === "technolandToCostPnL") {
                                                return (
                                                    <td key={col.key} className="whitespace-nowrap px-2 py-1">
                                                        <span
                                                            onClick={() =>
                                                                handlePnLClick(
                                                                    value,
                                                                    client,
                                                                    col.key === "clientToCostPnL" ? "Client" : "Technoland"
                                                                )
                                                            }
                                                            className={`cursor-pointer font-medium ${Number(value) >= 0 ? "text-green-600" : "text-red-600"
                                                                }`}
                                                        >
                                                            {value}
                                                        </span>
                                                    </td>
                                                );
                                            }


                                            return (
                                                <td key={col.key} className="whitespace-nowrap px-2 py-2 text-xs leading-tight">
                                                    {isLongText ? (
                                                        <Tooltip title={value} arrow>
                                                            <span className="inline-block truncate max-w-[200px] cursor-pointer">
                                                                {value}
                                                            </span>
                                                        </Tooltip>
                                                    ) : (
                                                        value
                                                    )}
                                                </td>
                                            );
                                        })}
                                    </tr>
                                    // <tr
                                    //     key={index}
                                    //     className="hover:bg-slate-50 border-b border-slate-200 text-center"
                                    // >
                                    //     {columns.map((col) => (
                                    //         <td key={col.key} className="whitespace-nowrap px-2 py-1">
                                    //             {(col.key === "clientToCostPnL" || col.key === "technolandToCostPnL") ? (
                                    //                 <span
                                    //                     onClick={() =>
                                    //                         handlePnLClick(
                                    //                             client[col.key],
                                    //                             client,
                                    //                             col.key === "clientToCostPnL" ? "Client" : "Technoland"
                                    //                         )
                                    //                     }
                                    //                     className={`cursor-pointer font-medium ${Number(client[col.key]) >= 0
                                    //                         ? "text-green-600"
                                    //                         : "text-red-600"
                                    //                         }`}
                                    //                 >
                                    //                     {client[col.key]}
                                    //                 </span>
                                    //             ) : (
                                    //                 client[col.key]
                                    //             )}
                                    //         </td>
                                    //     ))}
                                    // </tr>
                                ))
                            ) : (
                                <div className="flex justify-end">
                                    <NoResultFoundModel totalRecords={totalRecords} />
                                </div>
                            )}
                        </tbody>
                    </table>
                </div >
                {/* Pagination */}
                {(totalRecords >= pageSize) && (
                    <div className="flex justify-end">
                        <PaginationComponent
                            totalPages={Math.ceil(totalRecords / pageSize)}
                            currentPage={currentPage}
                            onPageChange={handlePageChange}
                        />
                    </div>
                )}

            </div >
        );
    };

    const renderLedgerTable = (data = []) => {
        if (!data.length) {
            return <NoResultFoundModel totalRecords={0} />;
        }

        return (
            <table className="w-full border-collapse border border-gray-200 text-12">
                <thead>
                    <tr className="bg-slate-100">
                        <th className="border p-2 text-left">Date</th>
                        <th className="border p-2 text-left">Description</th>
                        <th className="border p-2 text-right">Debit</th>
                        <th className="border p-2 text-right">Credit</th>
                        <th className="border p-2 text-right">Balance</th>
                    </tr>
                </thead>
                <tbody>
                    {data.map((row, index) => (
                        <tr key={index} className="border-b hover:bg-slate-50">
                            <td className="border p-2">
                                {row?.date?.split(" ")[0] || "-"}
                            </td>
                            <td className="border p-2">
                                {row.description || "-"}
                            </td>
                            <td className="border p-2 text-right text-red-600">
                                {row.debitAmount?.toFixed(2)}
                            </td>
                            <td className="border p-2 text-right text-green-600">
                                {row.creditAmount?.toFixed(2)}
                            </td>
                            <td className="border p-2 text-right font-medium">
                                {row.balanceAmount?.toFixed(2)}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        );
    };

    return (
        <div>
            <>
                <div className="bg-gray-50 mx-auto rep-width">
                    <div className="h-full bg-white shadow rounded-lg flex flex-col">
                        {/* Header Section */}

                        <div className="p-2 border-b flex flex-col lg:flex-row gap-3 items-start">
                            {/* Dropdown Filters */}
                            <div className="flex flex-wrap gap-2 w-full lg:w-[80%] items-start">
                                {/* Client filter */}
                                {/* <div className="w-full sm:w-[220px] flex-shrink-0">
                                    <Select
                                        options={lookupList?.clientList}
                                        placeholder="Select Client"
                                        isClearable
                                        styles={globalSelectStyles}
                                        onChange={async (selectedOptions) => {

                                            try {
                                                const res = await GetProjectLookupList(selectedOptions.value)

                                                if (res?.statusCode === 200) {
                                                    setLookupList({
                                                        ...lookupList,
                                                        projectList: mapToSelectOptions(
                                                            res?.responseData?.data || [],
                                                            "projectName",
                                                            "projectID"
                                                        ),

                                                    });
                                                }
                                            } catch (err) {
                                                console.log("error==>>", err)
                                            } finally {
                                                setAppliedFilter({
                                                    ...appliedFilter,
                                                    clientID: selectedOptions?.value
                                                })

                                            }
                                            setListId({
                                                ...listId,
                                                clientID: selectedOptions?.value
                                            })
                                        }}
                                        value={lookupList?.clientList?.find(
                                            (option) => option.value === listId?.clientID || null
                                        )}
                                    />
                                </div> */}
                                {/* Project Name Dropdown */}
                                {/* <div className="w-full sm:w-[220px] flex-shrink-0">
                                    <Select
                                        options={listId?.clientID ? lookupList?.projectList : []}
                                        placeholder="Select Project Name"
                                        isClearable
                                        styles={globalSelectStyles}
                                        onChange={(selectedOption) => {
                                            setAppliedFilter({
                                                ...appliedFilter,
                                                projectID: selectedOption?.value
                                            })
                                            setListId({
                                                ...listId,
                                                projectID: selectedOption?.value
                                            })
                                        }}
                                        value={lookupList?.projectList?.find(
                                            (option) => option?.value === listId?.projectID || ""
                                        )}
                                    />
                                </div> */}

                                {/* Employee Name Dropdown */}
                                {/* <div className="w-full sm:w-[220px] flex-shrink-0">
                                    <Select
                                        options={lookupList?.employeeList}
                                        placeholder="Select Employee Name"
                                        isClearable
                                        styles={globalSelectStyles}
                                        onChange={(options) => {
                                            setAppliedFilter({
                                                ...appliedFilter,
                                                userID: options?.value
                                            })
                                            setListId({
                                                ...listId,
                                                userID: options?.value
                                            })
                                        }}
                                    />
                                </div> */}

                                {/* category starts  */}
                                {/* <div className="w-full sm:w-[220px] flex-shrink-0">
                                    <Select
                                        options={lookupList?.jobCategoryList}
                                        placeholder="Select Category"
                                        isClearable
                                        styles={globalSelectStyles}
                                        onChange={(option) => {
                                            setListId({
                                                ...listId,
                                                jobCateogryID: option?.value
                                            })
                                            setAppliedFilter({
                                                ...appliedFilter,
                                                jobCateogryID: option?.value
                                            })
                                        }}

                                    />
                                </div> */}
                                {/* Status Name Dropdown */}
                                {/* <div className="w-full sm:w-[220px] flex-shrink-0">
                                    <Select
                                        options={lookupList?.statusList}
                                        placeholder="Select Status"
                                        isClearable
                                        styles={globalSelectStyles}
                                        onChange={(option) => {
                                            setListId({
                                                ...listId,
                                                jobStatusID: option?.value
                                            })
                                            setAppliedFilter({
                                                ...appliedFilter,
                                                jobStatusID: option?.value
                                            })
                                        }}

                                    />
                                </div> */}
                            </div>

                            {/* Right-side: Export + Search */}
                            <div className="flex items-start justify-end gap-2 w-full lg:w-[20%] flex-nowrap">
                                <button
                                    className="flex items-center text-[#135EA0] text-12"
                                    onClick={() => {
                                        setAppliedFilter({ ...appliedFilter, pageSize: 40 })

                                        setTimeout(() => {
                                            handleJobExport();
                                        }, 100);
                                    }}
                                >
                                    <FaFileExport className="m-2" />
                                    Export
                                </button>
                                {/* Filter Input */}

                                {/* Filter Button */}
                                {/* <button className="flex items-center text-[#135EA0] text-12">
                                  <FaFilter className="mr-1" />
                                  Filter
                                </button> */}
                                {/* Search Input */}

                                <div className="relative w-[220px]">
                                    <input
                                        type="text"
                                        className="w-full border border-gray-200 text-12 shadow appearance-none rounded py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline focus:ring-2 focus:ring-sky-600"
                                        placeholder="Search..."
                                        value={valueSearch}
                                        onChange={(e) => handleSearchFunction(e.target.value)}
                                    />
                                </div>
                            </div>
                        </div>

                        {/* Tab Content */}
                        <div className="flex flex-col table_wrapper border border-gray-200">
                            {/* <div className="flex-1 overflow-y-auto"> */}
                            {renderTable(tableColumnsConfig, tableRows || [])}

                            {/* </div> */}


                        </div>
                    </div>
                </div>
            </>

            {/* dialog box start  */}
            <Dialog open={openPnLDialog} onClose={handleCloseDialog} fullWidth maxWidth="md">
                {/* Header */}
                <div className="bg-[#ECF6FF] px-6 py-4 border-b flex justify-between items-center">
                    <h2 className="text-16 font-semibold">Summary</h2>
                    <button
                        className="text-gray-500 hover:text-gray-700"
                        onClick={handleCloseDialog}
                    >
                        ✕
                    </button>
                </div>


                {/* Content */}
                <DialogContent className="p-6 bg-gray-50 max-h-[75vh] overflow-y-auto">
                    <div className="bg-white border rounded-lg overflow-x-auto">
                        {renderLedgerTable(ledgerRows)}
                    </div>
                </DialogContent>


                {/* Footer */}
                <div className="sticky bottom-0 bg-white border-t z-20">
                    <div className="flex justify-end p-4">
                        <button
                            onClick={handleCloseDialog}
                            className="mx-2 px-4 py-2 bg-gray-300 rounded-md text-12"
                        >
                            Close
                        </button>
                    </div>
                </div>
            </Dialog>

        </div>
    )
}